module.exports = __webpack_public_path__ + "img/6.bd746106.png";